import * as types from "./mutation-type";
import { getEmailsQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";

const actions = {
  async getEmailTemplates({ commit }, variables = {}) {
    try {
      commit(types.GET_EMAILS_BEGIN);
      const {
        data: {
          data: {
            company: {
              emailTemplate
            }
          }
        }
      } = await gqlClient.query({
        query     : getEmailsQuery,
        variables : variables
      });
      commit(types.GET_EMAILS_SUCCESS, emailTemplate);
    } catch (e) {
      commit(types.GET_EMAILS_ERROR, e);
    }
  }
};

export default actions;